var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClinicMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 16 / icon_clinic_map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M10.7692 14H8V10.391H4.76923V14H2V2H10.7692V7.23308M10.7692 14V7.23308M10.7692 14H14V7.23308H10.7692",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClinicMap);
export default __webpack_public_path__ + "static/media/icon_clinic_map.6eda5bf0928b321ed3c701e99cb9cb48.svg";
export { ForwardRef as ReactComponent };